import * as types from "src/store/types/usuario";

const INITIAL_STATE = {
  loading: false,
  usuario: {},
  empresas: [],
  empresa_atual: {},
  select_empresa: false,
  permissoes: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.USUARIO_LOADING:
      return { ...state, loading: action.payload };
    case types.USUARIO_SET_USER:
      return { ...state, usuario: action.payload };
    case types.USUARIO_SET_EMPRESAS:
      return { ...state, empresas: action.payload };
    case types.USUARIO_SET_EMPRESA_ATUAL:
      return { ...state, empresa_atual: action.payload };
    case types.USUARIO_SET_SELECT_EMPRESA:
      return { ...state, select_empresa: action.payload };
    case types.USUARIO_SET_PERMISSOES:
      return { ...state, permissoes: action.payload };
    default:
      return state;
  }
};
